module.exports = "<tb-overview-react></tb-overview-react>";